<template>
    <div class="container-fluid m-0 p-0">
        <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
      <div class="col-sm-12 h-100 my-auto p-0 m-0">
        <span class="mx-3 font-weight-bold lead">User List</span>
        <span class="mx-3">
          <router-link
              :to="{name: 'UserCreate' }"
              tag="button"
              class="btn btn-sm btn-outline-primary font-weight-bolder"
              title="Add New User Record"
          >
                        <span class="fas fa-user-plus"></span>
                        Add User
                    </router-link>
        </span>
        <span class="float-right py-1 mx-2 pr-4">
          <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                  @click="goBack"
          >
                        <span class="fas fa-backward"></span>
                        Go Back
                    </button>
        </span>
      </div>
    </div>

        <div class="row text-small pt-3">
            <div class="col col-md-12">
              <div class="form-group form-inline">
                <label for="first-name" class="pr-3 font-weight-bold">First Name: </label>
                <input class="form-control form-control-sm" id="first-name" style=""
                       type="text" placeholder="Search First Name"
                       v-model="firstName"
                       @input="setPage(1)"
                >

                <label for="last-name" class="pr-3 font-weight-bold ml-3">Last Name: </label>
                <input class="form-control form-control-sm" id="last-name" style=""
                       type="text" placeholder="Search Last Name"
                       v-model="lastName"
                       @input="setPage(1)"
                >

                <label for="manning" class="pr-3 font-weight-bold ml-3">Manning: </label>
                <select name="rank" id="manning" class="form-control form-control-xs input-group-append"
                        v-model="manningId"
                        @change="setPage(0)"
                >
                  <option :value="null">--- Select Manning ---</option>
                  <option v-for="manningKey in manningKeys"
                          :key="manningKey.id"
                          :value="manningKey.id"
                          :title="manningKey.name"
                  >{{ manningKey.alias }}</option>
                </select>

                <label for="company" class="pr-3 font-weight-bold ml-3">Company: </label>
                <select name="company" id="rank" class="form-control form-control-xs input-group-append"
                        v-model="companyId"
                        @change="setPage(0)"
                >
                  <option :value="null">--- Select Company ---</option>
                  <option v-for="companyKey in companyKeys"
                          :key="companyKey.id"
                          :value="companyKey.id"
                  >{{ companyKey.name }}</option>
                </select>

<!--                <label for="inputUser" class="pr-3 font-weight-bold ml-5">Search User Here: </label>-->
<!--                <input class="form-control form-control-sm w-25" id="inputUser" style=""-->
<!--                       type="text" placeholder="Input Any Here . . ."-->
<!--                       v-model="searchText"-->
<!--                       @input="setPage(1)"-->
<!--                >-->
                <button type="button" class="btn btn-primary btn-sm ml-auto"
                        @click="searchText = ''; setPage(1)"
                >SEARCH</button>

              </div>

              <div class=" table-responsive text-small" style="height: 475px;">
                <table  id="userSummary" class="table table-hover table-bordered table-template-1 text-small sticky-header">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>LAST NAME</th>
                        <th>FIRST NAME</th>
                        <th>M. NAME</th>
                        <th>USERNAME</th>
                        <th>EMAIL</th>
                        <th>COMPANY</th>
                        <th>MANNING</th>
                        <th>POSITIONS</th>
                        <th>SYSTEM</th>
                        <th>STATUS</th>
                        <th class="">ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(user, index) in users" :key="user.id" :class="{ inactive: !user.active }">
                        <td>{{ index + pagination.from }}</td>
                        <td>{{ user.last_name }}</td>
                        <td>{{ user.name }}</td>
                        <td>{{ user.middle_name }}</td>
                        <td>{{ user.username }}</td>
                        <td>{{ user.email }}</td>
                        <td>{{ user.companyName }}</td>
                        <td :title="user.manningName">{{ user.manningAlias }}</td>
                        <td>{{ user.positions }}</td>
                        <td>{{ user.systems }}</td>
<!--                        <td>{{ user.positions.map(p => p.short_name).join('/')}}</td>-->
<!--                        <td>{{ user.systems.map(p => p.code).join('/')}}</td>-->
                        <td>{{ user.active ? 'ACTIVE' : 'INACTIVE' }}</td>
                        <td class="text-center">
                            <button class="btn btn-sm btn-xs btn-outline-info font-weight-bolder mr-1 ml-auto" @click="viewUser(user.id)">
                                <span class="fas fa-eye"></span>
                                View
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
              </div>

              <nav aria-label="...">
                <ul class="pagination text-smallest">
                  <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
                    <button class="page-link" @click="setPage(1)">First</button>
                  </li>

                  <li v-for="page in paginationPages" :key="page" class="page-item" :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
                    <button class="page-link" @click="setPage(page)">{{ page }}</button>
                  </li>

                  <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
                    <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
                  </li>
                </ul>
              </nav>

            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { paginationMixin } from "@/mixins/paginationMixin";

export default {
    name: "UserIndex",
    mixins: [ vueAppMixin, paginationMixin ],

    data() {
      return {
        searchText: '',
        firstName: null,
        lastName: null,
        manningId: null,
        companyId: null,
      }
    },

    methods: {
        ...mapActions([ 'getUsers', 'getManningKeys', 'getCompanyKeys' ]),
      initializeData() {
            this.getUsers({});
            this.getManningKeys();
            this.getCompanyKeys();
        },
        viewUser(userId) {
            this.$router.push({ name: 'UserShow', params: { id: userId }});
        },

        // TEMPORARY SEARCH .. THIS MAY NOT WORK ON PAGINATED TABLE
        findOnTables (event) {
          const search = event.target.value.toLowerCase();
          $("#userSummary tbody tr").filter(function () {
            $(this).toggle($(this).text().toLowerCase().indexOf(search) > -1)
          });
        },
        clearUserInput(event) {
          document.getElementById('inputUser').value = '';
          const search = event.target.value;
          $("#userSummary tbody tr").filter(function () {
            $(this).toggle($(this).text().toLowerCase().indexOf(search) > -1)
          });
        },

      setPage(page) {
        this.pagination.currentPage = page;
        this.searchUsers();
      },

      searchUsers() {
        let page = this.pagination.currentPage;
        let params = {
          page: page,
          searchText: this.searchText,
          firstName: this.firstName,
          lastName: this.lastName,
          manningId: this.manningId,
          companyId: this.companyId
        };
        this.getUsers(params);
      }

    },

    computed: {
        ...mapGetters(([ 'users', 'manningKeys', 'companyKeys' ]))
    },

    created() {
        this.initializeData();
    }

}
</script>

<style scoped>

</style>
